import * as styles from './Spinner.module.scss'

export default function Loader ({ className = '' }) {
  return (
    <div className={`${styles.container} ${className}`}>
      <div className={styles.spinner} />
    </div>
  )
}
